module.exports = __webpack_public_path__ + "media/PAG79-05.a2278c4c.mp3";